import {
    /** FETCH APPLICATION  */
    FETCH_APPROVEOTP_FULFILLED,
    FETCH_APPROVEOTP_REJECTED,
    FETCH_APPROVEOTP_PENDING,
    RESET_APPROVEOTP,
} from "../../actions/agreement/approveOtp";
const initialState = {
    done: false,
    error: false,
    spinner: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_APPROVEOTP_PENDING:
            return {
                done: false,
                error: false,
                spinner: true
            };
        case FETCH_APPROVEOTP_FULFILLED:
            return {
                ...state,
                approveOtp: action.payload,
                done: true,
                error: false,
                spinner: false
            };
        case FETCH_APPROVEOTP_REJECTED:
            return {
                ...state,
                error: action.payload,
                done: false,
                spinner: false
            };
        case RESET_APPROVEOTP:
            return {
                initialState,
                done: false,
                error: false,
                spinner: false
            };
        default:
            return state;
    }
};